module.exports = __webpack_public_path__ + "img/16c5811.jpg";